import { breakpoints } from '@ardoq/design-tokens';
import type { Observable } from 'rxjs';
import { fromMediaQuery } from './fromMediaQuery';

const NARROW_VIEWPORT_QUERY = `(width < ${breakpoints.tablet})`;

export const isViewportNarrow = (): boolean =>
  window.matchMedia(NARROW_VIEWPORT_QUERY).matches;

export const isViewportNarrow$: Observable<boolean> = fromMediaQuery(
  NARROW_VIEWPORT_QUERY
);
